import * as React from "react";
import { renderRoutes } from "react-router-config";
import { useQuery } from 'react-query';

import Header from "./Header";

import { EVIDENCE } from '../../Shared/utils/constants';
import { fetchUserRole } from '../../Shared/utils/userAPIs';
import { ReadAloudProvider, ScreenreaderInstructions, TeacherPreviewMenu, INTRODUCTION, getParameterByName, hasTeacherPreview } from '../../Shared/index';
import { onMobile } from '../../Shared/libs/onMobile';
import { routes } from "../routes";

const PageLayout = (props: any) => {
  const { user } = props;
  const turkSession = getParameterByName('turk', window.location.href);
  const activitySessionUid = getParameterByName('session', window.location.href);
  const isPlaying = window.location.href.includes('play');
  const { data } = useQuery("user-role", fetchUserRole);
  const isTeacherOrAdmin = data && data.role && data.role !== 'student';

  const [previewShowing, setPreviewShowing] = React.useState<boolean>(false);
  const [questionToPreview, setQuestionToPreview] = React.useState<any>(INTRODUCTION);
  const [isOnMobile, setIsOnMobile] = React.useState<boolean>(onMobile());

  // Header and TeacherPreviewMenu both render from this, so the listener belongs here rather
  // than in a child: tracking the breakpoint inside StudentViewContainer re-renders only that
  // subtree, leaving these siblings on a stale breakpoint until an unrelated parent update.
  // Setting the same boolean is a no-op, so this only re-renders on an actual crossing.
  React.useEffect(() => {
    const handleResize = () => setIsOnMobile(onMobile());

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  React.useEffect(() => {
    if((isTeacherOrAdmin || hasTeacherPreview()) && !turkSession) {
      setPreviewShowing(true)
    }
  }, [isTeacherOrAdmin])

  function handleSkipToMainContentClick () {
    const element = document.getElementById("main-content")
    if (!element) { return }
    element.focus()
    element.scrollIntoView()
  }

  function handleTogglePreviewMenu() {
    setPreviewShowing(!previewShowing);
  }

  function handleToggleQuestion(step: string) {
    setQuestionToPreview(step);
  }

  const showPreview = previewShowing && (isTeacherOrAdmin || hasTeacherPreview()) && isPlaying;
  const contentClass = showPreview ? 'evidence-preview-mode' : '';

  return (
    <div className="app-container">
      <ScreenreaderInstructions />
      <button className="skip-main" onClick={handleSkipToMainContentClick} type="button">Skip to main content</button>
      <Header isOnMobile={isOnMobile} isTeacher={isTeacherOrAdmin} onTogglePreview={handleTogglePreviewMenu} previewShowing={showPreview} />
      <div className="evidence-page-container">
        {showPreview && <div className="sider-container">
          <TeacherPreviewMenu
            isOnMobile={isOnMobile}
            onTogglePreview={handleTogglePreviewMenu}
            onToggleQuestion={handleToggleQuestion}
            questionToPreview={questionToPreview}
            showPreview={previewShowing}
          />
        </div>}
        <ReadAloudProvider activitySessionUid={activitySessionUid} tool={EVIDENCE}>
          <main className={contentClass} id="main-content" tabIndex={-1}>{renderRoutes(routes, {
            user,
            previewMode: showPreview,
            userRole: data?.role
          })}</main>
        </ReadAloudProvider>
      </div>
    </div>
  );
};

export default PageLayout;
